/* import React, { useState } from "react";
import { Cards, TitlePage } from "../../components";
import { content } from "../../Context/translate";
import { useFETCH } from "../../Tools/APIs";
import { Col } from "../../Tools/Grid-system";
import Loading from "../../Tools/Loading";
import { FaCheckCircle } from "react-icons/fa";
import { baseUrl } from "../../Tools/APIs";
import { browserName, browserVersion } from "../../Tools/APIs";

import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";

const stripePromise = loadStripe("pk_test_51RuH1vCfbiTRrdphrSPcogd63xozJBCRs39OYy7TQ33L75zEji95fdsHPrpkFT512xJLsbJ3SdGW0qJu4J4H5Per00VYiiyTnt"); 

export const FEATURES = [
  { key: "CHAT", name: "الدردشة" },
  { key: "PROFILE_VISITORS", name: "رؤية من زار بروفايلي" },
  { key: "CARES", name: "القدرة على اهتمام بشخص ما" },
  { key: "CHAT_NATIONALITIES", name: "القدرة على تحديد الجنسيات التي تراسلني" },
  { key: "CHAT_COUUNTRIES", name: "القدرة على تحديد البلدان التي تراسلني" },
  { key: "PREMIUM_SHOW", name: "الظهور في القائمة المميزة" },
];

const PREMIUM_DESCRIPTION =
  "باقة التميز هي مجموعة من الخدمات والخصائص المميزة، تزيد من فعاليتك في الموقع وتساعدك على إظهار ملفك بشكل أفضل وتزيد زيارات الأعضاء لملفك الشخصي وتحقيق هدفك بشكل أسرع";

const FeaturesCards = () => (
  <div className="flex flex-wrap gap-4 py-4 px-1 justify-center rounded-xl border border-sm shadow-md">
    {FEATURES.map((feature) => (
      <div
        key={feature.key}
        className="w-[220px] bg-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 border border-pink-100"
      >
        <span className="mb-3 text-pink-500">
          <FaCheckCircle size={32} />
        </span>
        <p className="text-center font-semibold text-gray-800">{feature.name}</p>
      </div>
    ))}
  </div>
);

const CheckoutForm = ({ clientSecret, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setLoading(true);

    if (!stripe || !elements) {
      setError(" لم يتم التحميل  بعد.");
      setLoading(false);
      return;
    }

    const cardElement = elements.getElement(CardElement);

    const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: cardElement,
      },
    });

    if (error) {
      setError(error.message);
      setLoading(false);
    } else if (paymentIntent && paymentIntent.status === "succeeded") {
      setLoading(false);
      onSuccess();
    } else {
      setError("حدث خطأ غير متوقع أثناء الدفع.");
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-md mx-auto p-4 bg-white rounded shadow">

      <div style={{ width: "400px" }}>
  <CardElement
    options={{
      style: {
        base: {
          fontSize: "18px",
          color: "#32325d",
        },
      },
      hidePostalCode: true,
    }}
  />
</div>

      {error && <div className="text-red-600 mt-2">{error}</div>}
      <button
        type="submit"
        disabled={!stripe || loading}
        className="mt-4 w-full bg-pink-500 text-white py-2 rounded hover:bg-pink-600 transition"
      >
        {loading ? "جارٍ الدفع..." : "ادفع الآن"}
      </button>
    </form>
  );
};

const Packages = () => {
  const { data, isLoading } = useFETCH("v1/packages");

  const [clientSecret, setClientSecret] = useState(null);
  const [paymentSuccess, setPaymentSuccess] = useState(false);

  if (isLoading) return <Loading />;

  const annualPackage = data?.data?.data?.find((pkg) => pkg.duration >= 360);

  const handleSubscribe = async (packageId) => {
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(baseUrl + "v1/payment/stripe/payment-intent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          finger_print: browserName + " " + browserVersion,
        },
        body: JSON.stringify({ package_id: packageId }),
      });

      const responseData = await res.json();

      if (!res.ok) throw new Error(responseData.message || "خطأ غير معروف");

      const secret =
        responseData.client_secret || responseData.data?.client_secret;

      if (!secret) throw new Error("client_secret غير موجود في الرد");

      setClientSecret(secret);
      setPaymentSuccess(false);
    } catch (error) {
      alert("حدث خطأ: " + error.message);
    }
  };

  const handlePaymentSuccess = () => {
    setPaymentSuccess(true);
    setClientSecret(null);
  };

  return (
    <Col md={11} className="mx-auto space-y-6">
      <TitlePage title={content.buyPackages} />
      <div className="bg-white rounded-xl shadow p-6 text-center max-w-2xl mx-auto">
        <h2 className="text-2xl font-bold text-pink-600 mb-2">باقة التميز</h2>
        <p className="text-gray-700 text-lg">{PREMIUM_DESCRIPTION}</p>
      </div>

      <FeaturesCards />

      <div className="flex justify-center mt-8">
        {annualPackage ? (
          <div className="bg-white rounded-xl shadow-lg p-8 flex flex-col items-center min-w-[320px] border border-pink-200">
            <h3 className="text-xl font-bold text-pink-600 mb-2">{annualPackage.name}</h3>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-gray-700 text-lg">مدة الاشتراك:</span>
              <span className="text-blue-900 font-semibold">{annualPackage.duration} يوم</span>
            </div>

            <div className="flex items-center gap-2 mb-4">
              <span className="text-gray-700 text-lg">عدد الرسائل:</span>
              <span className="text-gray-500 line-through text-lg">{annualPackage.messages_count}</span>
            </div>

            <div className="flex items-center gap-2 mb-4">
              <span className="text-gray-700 text-lg">السعر:</span>
              <span className="text-green-700 text-2xl font-bold">${annualPackage.new_price}</span>
              {annualPackage.old_price && (
                <span className="text-gray-500 line-through text-lg">${annualPackage.old_price}</span>
              )}
            </div>

            {!clientSecret && !paymentSuccess && (
              <button
                onClick={() => handleSubscribe(annualPackage.id)}
                className="mt-4 w-full rounded-lg bg-pink-500 py-3.5 px-7 text-center font-bold uppercase text-white shadow-md hover:shadow-lg transition-all"
                type="button"
              >
                {content.Subscribe}
              </button>
            )}

            {clientSecret && (
              <Elements stripe={stripePromise} options={{ clientSecret }}>
                <CheckoutForm clientSecret={clientSecret} onSuccess={handlePaymentSuccess} />
              </Elements>
            )}

            {paymentSuccess && (
              <div className="mt-4 text-green-700 font-bold text-center">
                تم الدفع بنجاح شكراً لاشتراكك.
              </div>
            )}
          </div>
        ) : (
          <Cards>
            <div className="flex justify-center items-center p-8">
              <h1 className="text-gray-700 text-2xl font-bold">لا يوجد باقة سنوية متاحة</h1>
            </div>
          </Cards>
        )}
      </div>
    </Col>
  );
};

export default Packages;
 */


import React, { useState } from "react";
import { Cards, TitlePage } from "../../components";
import { content } from "../../Context/translate";
import { useFETCH } from "../../Tools/APIs";
import { Col } from "../../Tools/Grid-system";
import Loading from "../../Tools/Loading";
import { FaCheckCircle } from "react-icons/fa";
import { baseUrl } from "../../Tools/APIs";
import { browserName, browserVersion } from "../../Tools/APIs";
import { useNavigate } from "react-router-dom";

export const FEATURES = [
  { key: "CHAT", name: "الدردشة" },
  { key: "PROFILE_VISITORS", name: "رؤية من زار بروفايلي" },
  { key: "CARES", name: "القدرة على اهتمام بشخص ما" },
  { key: "CHAT_NATIONALITIES", name: "القدرة على تحديد الجنسيات التي تراسلني" },
  { key: "CHAT_COUUNTRIES", name: "القدرة على تحديد البلدان التي تراسلني" },
  { key: "PREMIUM_SHOW", name: "الظهور في القائمة المميزة" },
];

const PREMIUM_DESCRIPTION =
  "باقة التميز هي مجموعة من الخدمات والخصائص المميزة، تزيد من فعاليتك في الموقع وتساعدك على إظهار ملفك بشكل أفضل وتزيد زيارات الأعضاء لملفك الشخصي وتحقيق هدفك بشكل أسرع";

const FeaturesCards = () => (
  <div className="flex flex-wrap gap-4 py-4 px-1 justify-center rounded-xl border border-sm shadow-md">
    {FEATURES.map((feature) => (
      <div
        key={feature.key}
        className="w-[220px] bg-white rounded-xl shadow-md flex flex-col items-center justify-center p-6 border border-pink-100"
      >
        <span className="mb-3 text-pink-500">
          <FaCheckCircle size={32} />
        </span>
        <p className="text-center font-semibold text-gray-800">{feature.name}</p>
      </div>
    ))}
  </div>
);

const Packages = () => {
  const { data, isLoading } = useFETCH("v1/packages");
  const navigate = useNavigate();

  if (isLoading) return <Loading />;

  const annualPackage = data?.data?.data?.find((pkg) => pkg.duration >= 360);

  const handleSubscribe = async (packageId) => {
    try {
      const token = localStorage.getItem("token");

      const res = await fetch(baseUrl + "v1/payment/stripe/payment-intent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          finger_print: browserName + " " + browserVersion,
        },
        body: JSON.stringify({ package_id: packageId }),
      });

      const responseData = await res.json();

      if (!res.ok) throw new Error(responseData.message || "خطأ غير معروف");

      const secret = responseData.client_secret || responseData.data?.client_secret;
      if (!secret) throw new Error("client_secret غير موجود في الرد");

      // الانتقال لصفحة الدفع
      navigate("/payment", { state: { clientSecret: secret } });
    } catch (error) {
      alert("حدث خطأ: " + error.message);
    }
  };

  return (
    <Col md={11} className="mx-auto space-y-6">
      <TitlePage title={content.buyPackages} />
      <div className="bg-white rounded-xl shadow p-6 text-center max-w-2xl mx-auto">
        <h2 className="text-2xl font-bold text-pink-600 mb-2">باقة التميز</h2>
        <p className="text-gray-700 text-lg">{PREMIUM_DESCRIPTION}</p>
      </div>

      <FeaturesCards />

      <div className="flex justify-center mt-8">
        {annualPackage ? (
          <div className="bg-white rounded-xl shadow-lg p-8 flex flex-col items-center min-w-[320px] border border-pink-200">
            <h3 className="text-xl font-bold text-pink-600 mb-2">{annualPackage.name}</h3>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-gray-700 text-lg">مدة الاشتراك:</span>
              <span className="text-blue-900 font-semibold">{annualPackage.duration} يوم</span>
            </div>

            <div className="flex items-center gap-2 mb-4">
              <span className="text-gray-700 text-lg">عدد الرسائل:</span>
              <span className="text-gray-500 line-through text-lg">{annualPackage.messages_count}</span>
            </div>

            <div className="flex items-center gap-2 mb-4">
              <span className="text-gray-700 text-lg">السعر:</span>
              <span className="text-green-700 text-2xl font-bold">${annualPackage.new_price}</span>
              {annualPackage.old_price && (
                <span className="text-gray-500 line-through text-lg">${annualPackage.old_price}</span>
              )}
            </div>

            <button
              onClick={() => handleSubscribe(annualPackage.id)}
              className="mt-4 w-full rounded-lg bg-pink-500 py-3.5 px-7 text-center font-bold uppercase text-white shadow-md hover:shadow-lg transition-all"
              type="button"
            >
              {content.Subscribe}
            </button>
          </div>
        ) : (
          <Cards>
            <div className="flex justify-center items-center p-8">
              <h1 className="text-gray-700 text-2xl font-bold">لا يوجد باقة سنوية متاحة</h1>
            </div>
          </Cards>
        )}
      </div>
    </Col>
  );
};

export default Packages;
